import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, SelectField, MenuItem, Toggle } from "material-ui"
import strings from "../../../../localization/strings"
import * as utils from "../../../../helpers/utils"
import ScriptCodeEditor from "../../../../components/common/script_code_editor/ScriptCodeEditor"
import { INoteType, IObjectAudit } from "../../../../models"
import AppStateStore from "../../../../stores/AppStateStore"
import AccountStore from "../../../../../app/stores/AccountStore"
import { IObjectSecurity } from "../../../../models/data/ObjectDetails"
import ObjectDetailsSecurity from "./../../../../components/object_audit/ObjectDetailsSecurity"

interface IProps {
    editNoteType: INoteType
    handleClose(): void
    handleAdd(noteType: INoteType): void
    handleUpdate(noteType: INoteType): void
}

interface IState {
    name: string
    group: string
    enableScripts: boolean
    frontEndScript: string
    frontEndPostValidationScript: string
    frontEndFormScript: string
    errorName: string
    dataType: string
    objectAttribute: boolean
    essFormBuilder: boolean
    essFormData: string
    objectSecurity: IObjectSecurity
    active: boolean
}

export default class AddNoteTypeDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const objectSecurity = props.editNoteType && props.editNoteType.ObjectAudit && props.editNoteType.ObjectAudit.Security ? props.editNoteType.ObjectAudit.Security :
            { EnableSecurity: false, ViewAccessRoleIdList: [], CreateAccessRoleIdList: [], DeleteAccessRoleIdList: [], WriteAccessRoleIdList: [] } as IObjectSecurity

        this.state = {
            name: props.editNoteType ? props.editNoteType.Name : "",
            group: props.editNoteType ? props.editNoteType.Group : "",
            enableScripts: props.editNoteType ? props.editNoteType.EnableScripts : false,
            frontEndScript: props.editNoteType && props.editNoteType.Scripts && props.editNoteType.Scripts.FrontEndScript ? props.editNoteType.Scripts.FrontEndScript : defaultValidationFormCode,
            frontEndFormScript: props.editNoteType && props.editNoteType.Scripts && props.editNoteType.Scripts.FrontEndFormScript ? props.editNoteType.Scripts.FrontEndFormScript : defaultHtmlText,
            frontEndPostValidationScript: props.editNoteType && props.editNoteType.Scripts && props.editNoteType.Scripts.FrontEndPostValidationScript ? props.editNoteType.Scripts.FrontEndPostValidationScript : defaultPostValidationScript,
            errorName: null,
            dataType: props.editNoteType && props.editNoteType.DataType ? props.editNoteType.DataType : "all",
            objectAttribute: props.editNoteType ? props.editNoteType.ObjectAttribute : false,
            essFormBuilder: props.editNoteType ? props.editNoteType.Scripts.EssFormBuilder : false,
            essFormData: props.editNoteType ? props.editNoteType.Scripts.EssFormData || "" : "",
            objectSecurity: objectSecurity,
            active: props.editNoteType ? props.editNoteType.Active : true
        }
        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return
        AppStateStore.setProgressSnackbarContent("loading")
        const payload: INoteType = this.getPayload()

        this.props.editNoteType ?
            this.props.handleUpdate(payload) :
            this.props.handleAdd(payload)
    }

    getPayload() {
        const objectAudit = this.props.editNoteType ? this.props.editNoteType.ObjectAudit :
            {
                Securitty: this.state.objectSecurity,
                Completed: false,
                CompletedDate: "",
                CompletedByName: "",
                CompletedByUserId: "",
                CompletedByS3Signature: "",
                CreatedDate: "",
                CreatedByName: "",
                CreatedByUserId: "",
                CreatedByAvatarS3URL: "",
                CreatedByGlobalAdmin: false,
                LastModified: "",
                LastModifiedByName: "",
                LastModifiedByUserId: "",
                LastModifiedByAvatarS3URL: "",
                LastModifiedByGlobalAdmin: false,
                Verified: false,
                VerifiedDateTime: "",
                VerifiedByName: "",
                VerifiedS3Signature: ""
            } as unknown as IObjectAudit;

        objectAudit.Security = this.state.objectSecurity

        const payload: INoteType = {
            Id: this.props.editNoteType ? this.props.editNoteType.Id : utils.guid(),
            Name: this.state.name.trim(),
            Group: this.state.group.trim(),
            EnableScripts: this.state.enableScripts,
            Scripts: {
                FrontEndFormScript: this.state.frontEndFormScript,
                FrontEndScript: this.state.frontEndScript,
                FrontEndPostValidationScript: this.state.frontEndPostValidationScript,
                EssFormBuilder: this.state.essFormBuilder,
                EssFormData: this.state.essFormData,
            },
            Deleted: false,
            TicksSinceChange: this.props.editNoteType ? this.props.editNoteType.TicksSinceChange : 0,
            DataType: this.state.dataType,
            ObjectAttribute: this.state.objectAttribute,
            Active: this.state.active,
            ObjectAudit: objectAudit,
        }

        return payload
    }

    checkValidate() {
        let isValidate = true
        return isValidate
    }

    render() {
        return (
            <Dialog
                open
                fullScreen
                title={strings.NoteType}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                contentStyle={{ width: "95%", maxWidth: "none" }}
                autoScrollBodyContent
                actions={[
                    <FlatButton
                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Btn-CloseAddScheduleJobDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Btn-SaveScheduleJob"}
                        label={strings.SAVE}
                        primary
                        onClick={this.handleSave}
                    />
                ]}
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <Toggle
                        fullWidth
                        toggled={this.state.active}
                        onToggle={(event, value) => this.setState({ active: value })}
                        labelPosition="left"
                        label={strings.Active}
                        style={{ width: 200, display: "inline-block", marginTop: 20 }}
                    />
                    <div style={{ display: "flex" }}>
                        <SelectField
                            data-intercom-target={"menu-AccountSettings-NoteType-Select-NoteDataType"}
                            floatingLabelText={"Data Type"}
                            value={this.state.dataType}
                            style={{ width: 400 }}
                            onChange={(e, i, dataType) =>
                                this.setState({ dataType })
                            }
                        >
                            <MenuItem value={"all"} primaryText={"All"} />
                            <MenuItem value={"client"} primaryText={"Client"} />
                            <MenuItem value={"job"} primaryText={"Job"} />
                            <MenuItem value={"timecard"} primaryText={"Timecard"} />
                            <MenuItem value={"payroll"} primaryText={"Payroll"} />
                            <MenuItem value={"user"} primaryText={"User"} />
                        </SelectField>

                        <Toggle
                            fullWidth
                            toggled={this.state.enableScripts}
                            onToggle={(event, value) => this.setState({ enableScripts: value })}
                            labelPosition="left"
                            label={"Enable Scripts"}
                            style={{ width: 200, display: "inline-block", marginLeft: 50, marginTop: 40 }}
                        />

                        {this.state.enableScripts && this.state.dataType && this.state.dataType != "all" && AccountStore.getNoteAttributesEnabled() &&
                            <Toggle
                                fullWidth
                                toggled={this.state.objectAttribute}
                                onToggle={(event, value) => { this.setState({ objectAttribute: value, essFormBuilder: this.state.essFormBuilder && value }) }}
                                labelPosition="left"
                                label={"Show Form Data As " + this.state.dataType.charAt(0).toUpperCase() + this.state.dataType.slice(1) + " Attributes?"}
                                style={{ width: 400, display: "inline-block", marginLeft: 50, marginTop: 40 }}
                            />
                        }

                        {this.state.enableScripts && this.state.dataType && this.state.dataType != "all" && this.state.objectAttribute && AccountStore.getNoteAttributesEnabled() &&
                            <Toggle
                                fullWidth
                                toggled={this.state.essFormBuilder}
                                onToggle={(event, value) => { this.setState({ essFormBuilder: value }) }}
                                labelPosition="left"
                                label={"ESS Form Builder"}
                                style={{ width: 400, display: "inline-block", marginLeft: 50, marginTop: 40 }}
                            />
                        }
                    </div>
                    <div style={{ display: "flex" }}>
                        <TextField
                            data-intercom-target={"menu-AccountSettings-NoteType-Add-Entry-Group"}
                            fullWidth
                            style={{ marginRight: 50 }}
                            floatingLabelText={strings.Group}
                            value={this.state.group}
                            onChange={(e, value) => { this.setState({ group: value }, () => this.checkValidate()) }}
                            errorText={this.state.errorName}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                        />
                        <TextField
                            data-intercom-target={"menu-AccountSettings-NoteType-Add-Entry-Name"}
                            fullWidth
                            style={{ marginRight: 50 }}
                            floatingLabelText={strings.NoteType}
                            value={this.state.name}
                            onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
                            errorText={this.state.errorName}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                        />
                    </div>

                    {
                        //https://www.data-driven-forms.org/installation
                    }

                    <Toggle
                        fullWidth
                        toggled={this.state.objectSecurity.EnableSecurity}
                        onToggle={(event, value) => {
                            let objectSecurity = this.state.objectSecurity

                            if (!objectSecurity) {
                                objectSecurity = {} as IObjectSecurity
                            }

                            objectSecurity.EnableSecurity = value
                            this.setState({ objectSecurity: objectSecurity })
                        }
                        }
                        labelPosition="left"
                        label={"Enhanced Security"}
                        style={{ width: 200, display: "inline-block", marginTop: 40 }}
                    />

                    {this.state.objectSecurity.EnableSecurity &&
                        <div style={{ marginTop: 20, marginBottom: 20 }}>
                            <ObjectDetailsSecurity
                                objectAuditSecurity={this.state.objectSecurity}
                                handleUpdate={(objectAuditSecurity: IObjectSecurity) => {
                                    this.setState({ objectSecurity: objectAuditSecurity })
                                }} />
                        </div>
                    }

                    {this.state.essFormBuilder && this.state.enableScripts &&
                        <ScriptCodeEditor
                            scriptCode={this.state.essFormData}
                            errorScriptCode={""}
                            handleChange={scriptCode => this.setState({ essFormData: scriptCode }, () => this.checkValidate())}
                            scriptLabel="Form Data"
                        />
                    }

                    {!this.state.essFormBuilder && this.state.enableScripts &&
                        <ScriptCodeEditor
                            scriptCode={this.state.frontEndFormScript}
                            errorScriptCode={""}
                            handleChange={scriptCode => this.setState({ frontEndFormScript: scriptCode }, () => this.checkValidate())}
                            scriptLabel="Front End Form (HTML)"
                        />
                    }
                    {!this.state.essFormBuilder && this.state.enableScripts &&
                        <ScriptCodeEditor
                            scriptCode={this.state.frontEndScript}
                            errorScriptCode={""}
                            handleChange={scriptCode => this.setState({ frontEndScript: scriptCode }, () => this.checkValidate())}
                            scriptLabel="Front End Submit Script (Javascript)"
                        />
                    }
                    {!this.state.essFormBuilder && this.state.enableScripts &&
                        <ScriptCodeEditor
                            scriptCode={this.state.frontEndPostValidationScript}
                            errorScriptCode={""}
                            handleChange={scriptCode => this.setState({ frontEndPostValidationScript: scriptCode }, () => this.checkValidate())}
                            scriptLabel="Front End Post Validation Submit Script (Javascript)"
                        />
                    }
                </div>
            </Dialog >
        )
    }
}

let defaultHtmlText = `
<div>
    <h4>Sample Script</h4>
    <select id="{SCOPEID}_option">
        <option value="Option 1">Option 1</option>
        <option value="Option 2">Option 2</option>
        <option value="Option 3">Option 3</option>
        <option value="Option 4">Option 4</option>
    </select>
    <h4>Please enter a date below:</h4>       
    <input type="date" id="{SCOPEID}_date"/>

    <h4>Sample Question?</h4>       
    <input type="checkbox" id="{SCOPEID}_sampleQuestion"/> <label for="{SCOPEID}_sampleQuestion">Question True/False?</label>
</div>`;


let defaultValidationFormCode = `
static submitForm(scopeId, account, user, accountUsers) { 
    var option = (document.getElementById(scopeId + "_option").value)
    var date = (document.getElementById(scopeId + "_date").value)
    var question = (document.getElementById(scopeId + "_sampleQuestion").value)
    var valid = true;
    var errorText = "";
    var noteTitle = "Option " + option + " on date " + date;
    var body = "Option: " + option + "\\nDate: " + date + "\\nQuestion: " + question;
    var formData = {
        option: option,
        date: date,
        question: question
    }

    if(!date){
        errorText += "Date is required";
        valid = false; 
    }

	return {
                success: valid, 
                errorText: errorText, 
                noteTitle: noteTitle, 
                noteBody: body, 
                formData: formData,
                noteSubscriberEmailList: "test@email.com, test2@email.com"
    };
}
`;

let defaultPostValidationScript = `
static postValidation(walledGardenUtil, account, user, accountUsers) { 
    var option = (document.getElementById(scopeId + "_option").value)
    var date = (document.getElementById(scopeId + "_date").value)
    var question = (document.getElementById(scopeId + "_sampleQuestion").value)
    var valid = true;
    var errorText = "";
    var noteTitle = "Option " + option + " on date " + date;
    var body = "Option: " + option + "\\nDate: " + date + "\\nQuestion: " + question;
    var formData = {
        option: option,
        date: date,
        question: question
    }

    if(!date){
        errorText += "Date is required";
        valid = false; 
    }

	return {
                success: valid, 
                errorText: errorText, 
                noteTitle: noteTitle, 
                noteBody: body, 
                formData: formData,
                noteSubscriberEmailList: "test@email.com, test2@email.com"
    };
}
`;